/*-------------------------------------------------------------------
グローバル変数
--------------------------------------------------------------------*/
let headerHeight;

/*-------------------------------------------------------------------
ドロワー：ボディスクロールロック
--------------------------------------------------------------------*/
function enableBodyScroll() {
  const scrollY = document.body.dataset.scrollY || "0";
  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.width = "";
  document.body.style.marginRight = "";

  // behavior: 'instant' は必ず明示する。
  // `_base.scss` の html { scroll-behavior: smooth } は JS の scrollTo にも効くため、
  // 省略するとドロワーを閉じた瞬間に一度トップへ飛んでから元の位置まで戻る（SP で顕著）。
  // 'auto' では直らない（'auto' は「CSS の指定に従う」＝ smooth のまま）。
  window.scrollTo({ top: parseInt(scrollY, 10), left: 0, behavior: "instant" });

  delete document.body.dataset.scrollY;
}

/*-------------------------------------------------------------------
関数定義
--------------------------------------------------------------------*/
function isPc() {
  return window.innerWidth >= 768;
}
// Mobileの場合True
function isMobile() {
  return !isPc();
}

// ============================================================
// アンカーリンクのスクロール
//
// スクロールの見た目は CSS に任せる（`_base.scss` の
//    `html { scroll-behavior: smooth }` + `scroll-padding-block-start`）。
//    JS で位置を自前計算しない。
//
// JS で位置を自前計算すると CSS と二重制御になり、
// 下層ページのアンカーで「下へ動く → 上に戻る → 該当セクションへ飛ぶ」の三段動作になる。
//   ブラウザが scroll-behavior: smooth でアンカーへ移動
//   load 時に window.scrollTo(0, 0) が走る
//   その後 JS の自前スクロールが走る
// という順で打ち消し合うため。
//
// ここで JS がやるのは「load 後にもう一度だけ位置を合わせ直す」ことだけ。
// 画像の遅延読み込みや Splide の初期化で高さが変わるので、
// 読み込み直後にブラウザが決めた位置は当てにならない。
// ============================================================

// ページ読み込み時のアンカージャンプはアニメーションさせない。
// 別ページから来た＝画面が切り替わった直後なので動きで見せる意味がなく、
// アニメーション中にレイアウトが動くと「行き過ぎて戻る」不自然な挙動になる。
if (location.hash) {
  document.documentElement.style.scrollBehavior = 'auto';
}

/**
 * ページ読み込み完了後にアンカー位置を合わせ直す
 */
function scrollHash() {
  const id = location.hash.slice(1);
  const target = id ? document.getElementById(id) : null;

  // ヘッダー分の逃げは CSS の scroll-padding-block-start が担当する
  if (target) target.scrollIntoView();

  // 以降の同一ページ内リンクは CSS の smooth で滑らかに動かす
  document.documentElement.style.scrollBehavior = '';
}


// /**
//  * ローディング画面
//  */
// function stopload() {
//   jQuery('#js-loading').delay(900).fadeOut(800);
// }

/*-------------------------------------------------------------------
読み込み時実行
--------------------------------------------------------------------*/
document.addEventListener("DOMContentLoaded", function () {
  headerHeight = document.querySelector('.js-header').offsetHeight;
  // setTimeout('stopload()', 10000);
});


/*-------------------------------------------------------------------
イベント
--------------------------------------------------------------------*/
/**
 * スクロールバーを除いた画面幅の取得
 */
jQuery(window).on('load resize', function () {
  let vw = document.body.clientWidth;// スクロールバーを除いた幅を取得
  let vh = window.innerHeight; // アドレスバーを覗いた画面高さ
  headerHeight = document.querySelector('.js-header').offsetHeight;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
});


// ローディング判定
jQuery(window).on("load", function () {
  jQuery("body").attr("data-loading", "true");
  // stopload();
});

/**
 * フェードしたページに戻るときに白飛びする対応
 */
window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    window.location.reload();
  }
});

jQuery(function () {
  // ページロード完了後にスクロールハッシュを実行
  jQuery(window).on('load', function() {
    scrollHash();
  });
  // gsap.to('body', { opacity: 1, duration: 0.5 });

  // スクロール判定
  jQuery(window).on("scroll", function () {
    let scrollTop = jQuery(this).scrollTop();
    let windowHeight = jQuery(this).height();
    let documentHeight = jQuery(document).height();

    if (100 < scrollTop) {
      jQuery("body").attr("data-scroll", "true");
    } else {
      jQuery("body").attr("data-scroll", "false");
    }

    if (documentHeight - (windowHeight + scrollTop) <= 0) {
      jQuery("body").attr("data-scroll-bottom", "true");
    } else {
      jQuery("body").attr("data-scroll-bottom", "false");
    }

  });

  /**
   * ハンバーガーボタンの aria-label を開閉状態に合わせる
   *
   * 関数化している理由：ドロワーを閉じる処理が 3 箇所ある
   * （トグル本体 / ページ内リンククリック / Escape キー）。
   * 1 箇所でも更新が漏れると「閉じているのにボタンは開いた状態を主張し続ける」ため、
   * 更新をこの関数 1 つにまとめる。閉じる処理を追加するときは必ずここも呼ぶこと。
   *
   * `button` に限定している。背景オーバーレイ（div）も `aria-controls` を持つが、
   * そちらは `aria-hidden="true"` の装飾なので aria-label は不要。
   */
  function syncDrawerLabel(isOpened) {
    jQuery('button[aria-controls="drawer-content1"]')
      .attr('aria-label', isOpened ? 'メニューを閉じる' : 'メニューを開く');
  }

  /**
   * ドロワーを閉じる
   *
   * 閉じ方が 4 通りある（ページ内リンク / Escape / 背景タップ / トグルボタン）。
   * トグルボタンだけは開閉が対になっていて isOpened から全部を導出する別構造なので、
   * 残る 3 通りをこの関数に寄せている。閉じ方を足すときは必ずここを呼ぶこと。
   * 属性を 1 つでも書き忘れると「閉じているのにボタンは開いた状態を主張し続ける」
   * `inert` が外れたままフォーカスが画面外へ抜ける といった形で壊れる。
   */
  function closeDrawer() {
    jQuery('.for-drawer').removeClass('is-opened');
    jQuery('#drawer-content1').attr('aria-hidden', 'true').attr('inert', '');
    jQuery('[aria-controls="drawer-content1"]').attr('aria-expanded', 'false').removeClass('is-opened');
    syncDrawerLabel(false);
    enableBodyScroll();
  }

  /* ドロワー
   * トグル後の状態を isOpened に一度だけ取り、
   * aria-expanded / aria-hidden / inert / スクロールロックを全てこの変数から導出する。
   * 各所で個別に hasClass を取り直すと状態管理の向きがバラつき、
   * aria-expanded とスクロールロックが真逆に動く・aria-hidden が更新されない等が起きる。
   */
  jQuery(".js-drawer").on("click", function (event) {
    event.preventDefault();
    const ariaControls = jQuery(this).attr("aria-controls");
    const addClass = 'is-opened';
    const $target = jQuery(`#${ariaControls}`);

    // toggle 状態を1回だけ取り、以降すべて isOpened を正本にする
    $target.toggleClass(addClass);
    const isOpened = $target.hasClass(addClass);

    // トリガーボタン側：aria-expanded と視覚状態を isOpened から統一導出
    jQuery(`[aria-controls=${ariaControls}]`).each(function () {
      jQuery(this).attr("aria-expanded", isOpened ? 'true' : 'false');
      if (isOpened) {
        jQuery(this).addClass(addClass);
      } else {
        jQuery(this).removeClass(addClass);
      }
    });
    syncDrawerLabel(isOpened);

    // ドロワー本体：aria-hidden と inert 属性でフォーカス到達を制御（aria-hidden-focus 対応）
    // 開閉のたびに更新しないと、初期値の aria-hidden="true" のまま開くことになる
    if (isOpened) {
      $target.attr('aria-hidden', 'false').removeAttr('inert');
    } else {
      $target.attr('aria-hidden', 'true').attr('inert', '');
    }

    // ボディスクロールロック：開時に fixed 固定・閉時に解除（旧実装は真逆だった）
    if (isOpened) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      const scrollY = window.scrollY;

      // admin bar 分を差し引く。
      // WordPress はログイン中だけ html { margin-top: 32px !important }（SP 幅では 46px）を出す。
      // body を position: fixed にすると基準が viewport に移ってこの margin-top が効かなくなり、
      // 後ろのコンテンツが 32px 上にずれる。未ログインでは margin-top が 0 なので再現しない。
      // 高さは幅 782px を境に 32 / 46 と変わるため、固定値ではなく computed をその場で読む。
      const adminBarOffset = parseFloat(getComputedStyle(document.documentElement).marginTop) || 0;

      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY - adminBarOffset}px`;
      document.body.style.width = `calc(100% - ${scrollbarWidth}px)`;
      document.body.style.marginRight = `${scrollbarWidth}px`;
      document.body.dataset.scrollY = String(scrollY);
    } else {
      enableBodyScroll();
    }

    return false;
  });

  /**
   * ドロワー内のページ内リンククリック時に閉じる
   * トリガーボタン側の aria-expanded / クラス / ラベルもここで戻すこと。
   * 忘れると閉じた後もボタンが aria-expanded="true" のまま残る。
   */
  jQuery('#drawer-content1 a[href*="#"]').on('click', function (event) {
    const currentUrl = location.protocol + '//' + location.host + location.pathname; // 現在のURL
    const href = jQuery(this).prop("href");
    const hrefUrl = href.split('#')[0];   // リンク先のURL

    if (currentUrl == hrefUrl) {
      closeDrawer();
    }
  });

  /**
   * ドロワーの空白部分をタップして閉じる
   *
   * カンプのドロワーは全画面カバーで、テンプレ既定の背景オーバーレイ（.p-drawer__bg）は
   * ドロワー本体の下に完全に隠れて触れない。「メニューの外側」が物理的に無いため、
   * ドロワー本体側で受けている。
   *
   * .p-drawer__navList を除外している理由：項目の高さは 27px でピッチが 61px あり、
   * 隙間 34px を含めて閉じる対象にすると、リンクを狙って少し外しただけで閉じてしまう。
   * リンク・ボタンの除外は、閉じる処理が遷移に割り込まないようにするため。
   *
   * キーボードからは到達できないが、閉じる操作は Escape と ハンバーガーボタンで
   * 担保済みなので、これは補助手段という位置づけ（drawer.php の背景と同じ考え方）。
   */
  jQuery('#drawer-content1').on('click', function (event) {
    if (jQuery(event.target).closest('.p-drawer__navList, a, button').length) {
      return;
    }
    closeDrawer();
  });

  /* ヘッダー：data-scroll-target で指定した要素（TOP は FV）を過ぎたら背景を付ける
   *
   * クラス名は is-scrolled。本案件のヘッダーは「隠れていたものが固定される」のではなく
   * 「透過だったものに背景が付く」ので、is-fixed では意味が合わない。
   *
   * 付け外しは toggleClass で常に同期させる。
   * `else if (position == 0)` の形にすると、閾値以下まで戻してもスクロール位置が
   * ちょうど 0 でない限りクラスが外れず、FV の途中で背景が付いたまま残る。
   */
  jQuery(window).on('load scroll', function () {
    const $header = jQuery('.js-header');
    if (!$header.length) return;

    // 属性は data-scroll-target。data-target にすると [data-target] { cursor: pointer } が
    // ヘッダー全体に当たる（あちらはクリックで開閉する対象を指す属性）。
    const target = jQuery(`.${$header.data('scrollTarget')}`);
    // 対象要素が無いページ（下層）ではヘッダー高の 1.1 倍を閾値にする
    const targetHeight = (target.length ? target.innerHeight() : headerHeight * 1.1);

    $header.toggleClass('is-scrolled', jQuery(this).scrollTop() > targetHeight);
  });


  /* スムーススクロール：JS では実装しない
   *
   * 同一ページ内のアンカーは preventDefault() せずブラウザに任せる。
   * `_base.scss` の html { scroll-behavior: smooth } + scroll-padding-block-start で
   * 滑らかさもヘッダー分の逃げも足りるため、JS で位置を計算しない。
   * 自前実装を足すと CSS と二重制御になって不自然な動きになる（上の注記を参照）。
   *
   * ブラウザ任せだと URL に `#service` が残るが、これは正しい挙動
   * （リロードや共有で同じ位置に戻れる）。消さないこと。
   */

  /* 電話リンク */
  const $ua = navigator.userAgent;
  if ($ua.indexOf("iPhone") < 0 && $ua.indexOf("Android") < 0) {  // PCのとき
    jQuery('a[href^="tel:"]') // 電話リンク
      .css("cursor", "default") // カーソルをポインターにしない
      .css('pointer-events', 'none')  // ホバーなども動作しない
      .on("click", function (e) {
        e.preventDefault();
      });
  }

  /* ドロワー：Escapeキーで閉じる */
  jQuery(document).on('keydown', function (event) {
    if (event.key === 'Escape' && jQuery('#drawer-content1').hasClass('is-opened')) {
      closeDrawer();

      // フォーカスをハンバーガーボタンに戻す（WCAG 2.4.3）
      // Escape で閉じるとフォーカスが inert になったドロワー内に取り残され、
      // キーボード操作では現在位置が分からなくなる。
      // クリックで閉じる場合はボタン自身がクリックされるので戻し不要。Escape だけの問題。
      //
      // jQuery の .trigger('focus') は使わない。
      // イベントシミュレーション経由では実フォーカスが移らず、
      // document.activeElement が <body> のまま変わらない。素の DOM の focus() を呼ぶ。
      const $hamburger = jQuery('button[aria-controls="drawer-content1"]');
      if ($hamburger.length) {
        $hamburger[0].focus();
      }
    }
  });

  /* ドロワー：フォーカストラップ（静的メニュー使用時のみ有効） */
  const focusTrap = document.getElementById('js-focus-trap');
  const hamburgerBtn = document.querySelector('.js-drawer[aria-controls="drawer-content1"]');
  if (focusTrap && hamburgerBtn) {
    focusTrap.addEventListener('focus', function () {
      hamburgerBtn.focus();
    });
  }

});
